const sizes = {
    small: 30,
    medium: 36,
    large: 48,
};

export default {
    sizes,
};
